<template>
  <div>
    <transition name="fade" mode="out-in">
      <v-alert v-if="wasForgottenEmailSent" text type="success" dense
        >An email was sent to the Shop Owner.</v-alert
      >
      <BtnBaseBlue
        v-else
        :loading="isSendingEmail"
        @click="sendForgottenEmail"
        large
        >Send Email to Shop Owner</BtnBaseBlue
      >
    </transition>
    <transition name="fade" mode="out-in">
      <v-alert v-if="!!error" text type="warning" class="text-left mt-2"
        >There was a problem sending the email to the Shop Owner. Please try
        again or contact
        <a href="mailto:hi@getminimart.com">hi@getminimart.com</a> for
        assistance.</v-alert
      >
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _get from 'lodash/get'
import BtnBaseBlue from '@/components/BtnBaseBlue'

export default {
  name: 'SendForgotEmailButton',
  components: { BtnBaseBlue },
  data() {
    return {
      wasForgottenEmailSent: false,
      isSendingEmail: false,
      error: false,
    }
  },
  methods: {
    ...mapActions('auth', ['sendForgottenEmailEmail']),
    async sendForgottenEmail() {
      this.isSendingEmail = true
      this.wasForgottenEmailSent = false
      try {
        await this.sendForgottenEmailEmail()
        this.wasForgottenEmailSent = true
        setTimeout(() => {
          this.wasForgottenEmailSent = false
        }, 10000)
        this.error = false
      } catch (error) {
        this.error = _get(
          error,
          'response.data.message',
          'Sorry but we were unable to send an email to the Shop owner.'
        )
      } finally {
        this.isSendingEmail = false
      }
    }, // sendForgottenEmail
  },
}
</script>
